import { EXPORT_RUNS } from '@src/graphql/queries/exportRun';
// eslint-disable-next-line export/no-extraneous-dependencies
import { usePaginatedFetchItems } from 'pe-core-frontend';
export const useExportRuns = ({ clientId }) => {
    const { page, setPage, pageSize, setPageSize, orderBy, setOrderBy, orderByDir, setOrderByDir, total, items: exportRuns, loading, error, find, } = usePaginatedFetchItems({
        spec: { clientId },
        fetchQuery: EXPORT_RUNS,
        dataProp: 'exportRuns',
        initialPageSize: 10,
    });
    return {
        exportRuns,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        orderBy,
        setOrderBy,
        orderByDir,
        setOrderByDir,
        error,
        total,
        find,
    };
};
